import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 100px);
  background: linear-gradient(to bottom, #fafbfc 0%, #ffffff 100%);
`;

export const Header = styled.div`
  padding: 10px 32px;
  border-bottom: 1px solid #e8eaed;
  background: #ffffff;

  h2 {
    margin: 0;
    font-size: 1.75rem;
    font-weight: 600;
    color: #1a1a1a;
    letter-spacing: -0.5px;
  }

  @media (max-width: 768px) {
    padding: 10px;

    h2 {
      font-size: 1.5rem;
    }
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 10px 28px 32px;

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f3f4;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c7cd;
    border-radius: 4px;
    
    &:hover {
      background: #9aa0a6;
    }
  }

  @media (max-width: 768px) {
    padding: 0 20px 20px 20px;
  }
`;

export const FormContainer = styled.div`
  padding: 24px 0px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;

  /* Style MUI TextField */
  .MuiOutlinedInput-root {
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    &.Mui-focused {
      box-shadow: 0 2px 12px rgba(25, 118, 210, 0.15);
    }
  }

  .MuiInputLabel-root {
    font-weight: 500;
  }
`;

export const FixedFooter = styled.div`
  border-top: 1px solid #e8eaed;
  background: #ffffff;
  padding: 20px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 768px) {
    padding: 16px 20px;
  }
`;

export const SummaryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border: 1px solid #dee2e6;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);

  span {
    font-weight: 600;
    color: #1a1a1a;
    font-size: 0.80rem;

    &:last-child {
      color: #198754;
      font-size: 1rem;
      letter-spacing: -0.3px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    span {
      font-size: 0.9rem;

      &:last-child {
        font-size: 1rem;
      }
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;

  button {
    min-width: 140px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.2s ease;
    text-transform: none;
    font-size: 0.95rem;
    padding: 10px 24px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;

    button {
      min-width: 100%;
    }
  }
`;
